import { render, staticRenderFns } from "./PageCart.vue?vue&type=template&id=9732d420&"
import script from "./PageCart.vue?vue&type=script&lang=js&"
export * from "./PageCart.vue?vue&type=script&lang=js&"
import style0 from "./PageCart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports